import React, { useEffect, useState } from "react";
import MobilePage, {
  PageContent,
  PageHeader,
} from "../../../Components/MobilePage";
import useMyOrdersList from "../../../../hooks/useMyOrdersList";
import { Trans } from "react-i18next";
import styled from "styled-components";
import { useHistory, useRouteMatch } from "react-router-dom";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useAPI } from "../../../../lib/common";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import { formatFullDate } from "../../../../utils";
import AppBar from "../../Components/AppBar";
import OrderContent from "../../../Components/Checkout/OrderContent";
import Box from "@material-ui/core/Box";

const OrderList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  > li {
    margin-bottom: 8px;
  }
`;

const useStyles = makeStyles((theme) => {
  console.log("Make style props", theme);
  return {
    column: {
      flexBasis: "33.33%",
    },
    summary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  };
});

export default () => {
  const [orderList, loading] = useMyOrdersList();

  if (loading) {
    return null;
  }

  return (
    <MobilePage requireUser={true}>
      <AppBar />
      <PageHeader>
        <Trans>My orders</Trans>
      </PageHeader>
      <PageContent>
        <Container>
          <OrderList>
            {orderList.map((order) => {
              return <Order key={order.uuid} order={order} />;
            })}
          </OrderList>
        </Container>
      </PageContent>
    </MobilePage>
  );
};

const Order = ({ order }) => {
  const { params } = useRouteMatch();
  const classes = useStyles();
  const history = useHistory();

  const handleChange = (evt, expanded) => {
    if (expanded) {
      history.replace(`/my-account/orders/${order.uuid}`);
    } else {
      history.replace("/my-account/orders");
    }
  };

  return (
    <li>
      <ExpansionPanel
        expanded={params.orderUuid == order.uuid}
        onChange={handleChange}
      >
        <ExpansionPanelSummary
          className={classes.summary}
          expandIcon={<ExpandMoreIcon />}
        >
          <div className={classes.column}>
            {formatFullDate(order.confirmTime)}
          </div>
          <div className={classes.column}>#{order.uuid.substring(0, 8)}</div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {params.orderUuid == order.uuid && (
            <OrderDetails uuid={order.uuid} />
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </li>
  );
};

const OrderDetails = ({ uuid }) => {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    fetch("/sections/my-account/ajax/get_order_details.php?uuid=" + uuid)
      .then((r) => r.json())
      .then((json) => setDetails(json));
  }, []);
  if (!details) {
    return (
      <div>
        <Trans>Loading details</Trans>
      </div>
    );
  }

  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <OrderContent
        orderLines={details.orderLines}
        hasActiveRebateCampaigns={false}
        rebateCode={details.rebateCode}
      />
    </Box>
  );
};

export { OrderDetails };
